module.exports = __webpack_public_path__ + "static/media/中央民族大学新校区-min.52fb22e9.jpg";